// Centralized site data for Happy Journey 4 U
export const BRAND = {
  webName: "Happy Journey 4 U",
  legalName: "Jayesh Tour Packages & Travellers",
  established: 2017,
  owner: "Lucky Jeswani",
  address: "2 Sarthak Plaza Complex, Dakwadi, Burhanpur 450331",
  phones: [
    { label: "Primary", number: "+91 9753277771", raw: "919753277771" },
    { label: "Secondary", number: "+91 9753299991", raw: "919753299991" },
  ],
  email: "support@happyjourney4u.co.in",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_8be32edd-d3d5-4fc7-a743-90b318c317bf/artifacts/0sqv7zpy_image.png",
  mapsEmbed:
    "https://www.google.com/maps?q=2+Sarthak+Plaza+Complex,+Dakwadi,+Burhanpur+450331&output=embed",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "destinations", label: "Destinations" },
  { id: "why", label: "Why Us" },
  { id: "contact", label: "Contact" },
];

export const HERO_SLIDES = [
  {
    image:
      "https://images.pexels.com/photos/31566720/pexels-photo-31566720.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
    place: "Dubai",
    tagline: "Skylines that touch the clouds",
  },
  {
    image:
      "https://images.pexels.com/photos/36913571/pexels-photo-36913571.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
    place: "Bali",
    tagline: "Where the ocean meets paradise",
  },
  {
    image:
      "https://images.pexels.com/photos/31088465/pexels-photo-31088465.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
    place: "Kashmir",
    tagline: "Heaven dressed in snow",
  },
  {
    image:
      "https://images.pexels.com/photos/26737102/pexels-photo-26737102.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
    place: "Europe",
    tagline: "Cobblestoned tales of old world charm",
  },
  {
    image:
      "https://images.pexels.com/photos/28520254/pexels-photo-28520254.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
    place: "Goa",
    tagline: "Sunsets over the Arabian Sea",
  },
];

export const SERVICES = [
  {
    title: "Domestic Tour Packages",
    desc: "Curated journeys across India — from Himalayan retreats in Manali & Kashmir to coastal escapes in Goa, Andaman and Kerala.",
    icon: "MapPin",
    accent: "from-amber-100 to-orange-50",
  },
  {
    title: "International Tour Packages",
    desc: "Visa-ready holiday plans across Dubai, Thailand, Bali, Singapore, Europe and Maldives — handcrafted for every budget.",
    icon: "Globe2",
    accent: "from-sky-100 to-blue-50",
  },
  {
    title: "Visa Assistance",
    desc: "End-to-end guidance for tourist & business visas with documentation help, appointment scheduling and follow-ups.",
    icon: "FileCheck2",
    accent: "from-emerald-100 to-teal-50",
  },
  {
    title: "Air Ticket Booking",
    desc: "Best-fare domestic & international flights with flexible date suggestions and 24×7 support before takeoff.",
    icon: "Plane",
    accent: "from-orange-100 to-rose-50",
  },
  {
    title: "Train Ticket Booking",
    desc: "Confirmed Indian Railways reservations, tatkal assistance and multi-city itineraries booked through verified channels.",
    icon: "TrainFront",
    accent: "from-indigo-100 to-blue-50",
  },
  {
    title: "Hotel Bookings",
    desc: "From boutique homestays to 5-star luxury resorts — negotiated rates and verified properties across the globe.",
    icon: "Hotel",
    accent: "from-yellow-100 to-amber-50",
  },
  {
    title: "Car Transport & Rentals",
    desc: "Airport transfers, intercity cabs, self-drive cars and tempo travellers for groups — clean, AC, well-maintained fleet.",
    icon: "CarFront",
    accent: "from-cyan-100 to-sky-50",
  },
  {
    title: "Honeymoon & Group Tours",
    desc: "Romantic getaways and curated group departures with experienced tour leaders — memories crafted with care.",
    icon: "HeartHandshake",
    accent: "from-rose-100 to-pink-50",
  },
];

export const DESTINATIONS = [
  {
    name: "Dubai",
    country: "United Arab Emirates",
    image:
      "https://images.pexels.com/photos/31566720/pexels-photo-31566720.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    duration: "5N / 6D",
    tag: "International",
  },
  {
    name: "Bali",
    country: "Indonesia",
    image:
      "https://images.pexels.com/photos/36913571/pexels-photo-36913571.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    duration: "6N / 7D",
    tag: "Honeymoon",
  },
  {
    name: "Kashmir",
    country: "India",
    image:
      "https://images.pexels.com/photos/31088465/pexels-photo-31088465.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    duration: "4N / 5D",
    tag: "Domestic",
  },
  {
    name: "Europe",
    country: "Multi-country",
    image:
      "https://images.pexels.com/photos/26737102/pexels-photo-26737102.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    duration: "10N / 11D",
    tag: "Premium",
  },
  {
    name: "Goa",
    country: "India",
    image:
      "https://images.pexels.com/photos/28520254/pexels-photo-28520254.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    duration: "3N / 4D",
    tag: "Quick Getaway",
  },
  {
    name: "Manali",
    country: "India",
    image:
      "https://images.pexels.com/photos/36393554/pexels-photo-36393554.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    duration: "5N / 6D",
    tag: "Domestic",
  },
  {
    name: "Thailand",
    country: "Southeast Asia",
    image:
      "https://images.pexels.com/photos/32763065/pexels-photo-32763065.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    duration: "5N / 6D",
    tag: "Bestseller",
  },
];

export const WHY_US = [
  {
    title: "8+ Years of Trust",
    desc: "Serving Burhanpur and travelers across MP since 2017 under Jayesh Tour Packages & Travellers.",
    icon: "ShieldCheck",
    metric: "8+",
    metricLabel: "Years",
  },
  {
    title: "10,000+ Happy Travellers",
    desc: "From solo adventurers to corporate groups — we have crafted memories for thousands.",
    icon: "Users",
    metric: "10k+",
    metricLabel: "Travellers",
  },
  {
    title: "Personal Tour Manager",
    desc: "Direct WhatsApp support with Lucky Jeswani's team — no call centers, no scripts.",
    icon: "Headphones",
    metric: "24×7",
    metricLabel: "Support",
  },
  {
    title: "Best Price Guarantee",
    desc: "Transparent quotes, no hidden charges — and we will match any genuine lower offer.",
    icon: "BadgeIndianRupee",
    metric: "100%",
    metricLabel: "Transparent",
  },
];
